<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-09-24 09:11:38
 * @LastEditors: Yehon He 1427749162@qq.com
 * @LastEditTime: 2025-04-02 00:11:54
-->
<template>
    <config-wrap :title="label">
        <custom-schema-template :schema="schema.attrs" v-model="control.curWidget.attrs"></custom-schema-template>
        <div class="mb10 f-grey f12">{{ mOptions.note }}</div>
        <div class="nav">
            <!-- <config-item label='数据源'>
                <div class="flex-row flex-end">
                    <el-radio-group v-model="sourceType" size="small" class="ml-auto">
                        <el-radio-button label="live">直播</el-radio-button>
                        <el-radio-button label="video">视频</el-radio-button>
                    </el-radio-group>
                </div>
            </config-item> -->
            <div class="nav-add mb10" @click="openDynamicLiveDialog">选择动态数据</div>
            <div class="nav-add mb10" @click="openDialog">选择数据源</div>
            <draggable v-model="mValue">
                <!-- 编译模式,插槽可供自定义拖拽组件入容器 -->
                <slot v-if="edit"></slot>

                <!-- 非编译模式，根据schema子类遍历数组单项组件 -->
                <template v-else>
                    <div v-for="item in mValue" :key="item.id" class="nav-item">
                        <!-- 只显示标题和封面，不显示链接和状态 -->
                        <component v-for="(val, key, index) in filteredSchemaChild" :key="index"
                            :is="typeToComponent[val.type]" v-model="item[key]" v-bind="val">
                        </component>
                        <div class="nav-delete" @click="delItem(item.id)">x</div>
                    </div>
                </template>
            </draggable>
        </div>

        <el-dialog v-if="dialogVisible" :title="dialogTitle" :visible.sync="dialogVisible" :top="dialogTop"
            :width="dialogWidth">
            <!-- <div v-if="!isShowCustomData">
                <config-item label='一级分类'>
                    <el-select v-model="liveType1" placeholder="请选择一级分类" value-key="_id" @change="getliveList">
                        <el-option v-for="item in liveTypeList" :key="item._id" :label="item.name" :value="item._id">
                        </el-option>
                    </el-select>
                </config-item>

                <config-item v-if="liveType1" label='二级分类'>
                    <el-select v-model="liveType2" placeholder="请选择二级分类" clearable value-key="id" @change="getliveList">
                        <el-option v-for="item in secondTypeList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </config-item>

                <config-item label='预设跳转'>
                    <el-select v-model="customUrl" placeholder="请选择要跳转的自定义页面" value-key="id">
                        <el-option v-for="(page, i) in customPages" :key="i" :label="page.name" :value="page.id">
                        </el-option>
                    </el-select>
                </config-item>
            </div> -->

            <live-list v-if="liveVisible" @onChangeSelection="handleSelectionChange"></live-list>
            
            <live-type-list v-if="liveTypeVisible" ref="liveTypeRef"></live-type-list>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="done">确 定</el-button>
            </span>
        </el-dialog>
    </config-wrap>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";
import typeToComponent from "@/config/schema-template";
import { getLiveTypeList, getLiveList, checkLiveRooms } from "@/api/material";
import LiveList from "@/pages/mall/live/components/list.vue"
import LiveTypeList from "@/pages/mall/live/components/TypeList.vue"
import { mapGetters } from "vuex";


export default {
    name: "SchemaLive",

    mixins: [schemaMixin],

    components: {
        LiveList,
        LiveTypeList,
    },

    props: {
        label: {
            type: String,
            default: "",
        },
        edit: {
            type: Boolean,
            default: false,
        },
        schema: {
            type: Object,
            default: () => { },
        },
    },

    inject: ["control"],

    data() {
        return {
            typeToComponent,
            list: [],
            liveTypeList: [],
            liveType1: '',
            liveType2: '',
            customUrl: '/pages/index/live/detail',
            dialogVisible: false,
            dialogTitle: "选择数据源",
            isShowCustomData: true,
            sourceType: 'live',
            liveVisible: false,
            videoVisible: false,
            liveTypeVisible: false,
            cacheKey: 'schema_live_data'
        };
    },

    async created() {
        // 初始化时检查已选择的直播间是否被删除
        await this.checkDeletedLives();
        // 清除可能存在的缓存数据
        localStorage.removeItem(this.cacheKey);
    },

    computed: {
        // isShowCustomData() {
        //     return this.control.curWidget.attrs.dataMode == 'custom';
        // },
        dialogWidth() {
            return this.isShowCustomData ? '1200px' : '300px';
        },
        dialogTop() {
            return this.isShowCustomData ? '5vh' : void 0;
        },
        secondTypeList() {
            return this.liveTypeList.find(item => item._id == this.control.curWidget.attrs.liveType1)?.child || [];
        },
        ...mapGetters(["project"]),
        customPages() {
            return this.project.pages;
        },
        // 过滤掉不需要显示的字段
        filteredSchemaChild() {
            const result = {};
            Object.entries(this.schema.child).forEach(([key, value]) => {
                // 排除直播链接和状态字段
                if (key !== 'liveUrl' && key !== 'status') {
                    result[key] = value;
                }
            });
            return result;
        }
    },

    watch: {
        'control.curWidget.attrs.dataMode': {
            handler() {
                this.list = [];
            },
            deep: true,
        },
        dialogVisible: {
            async handler(val) {
                if (!val) {
                    this.liveVisible = false;
                    this.videoVisible = false;
                    this.liveTypeVisible = false;
                    this.list = [];
                } else {
                    // 打开对话框时，强制检查并更新数据
                    await this.checkDeletedLives();
                }
            }
        },
        // 监听 mValue 变化，更新缓存
        mValue: {
            handler(newVal) {
                if (newVal) {
                    localStorage.setItem(this.cacheKey, JSON.stringify(newVal));
                }
            },
            deep: true
        }
    },

    methods: {
        // 检查已选择的直播间是否被删除
        async checkDeletedLives() {
            try {
                if (!this.mValue || !Array.isArray(this.mValue) || this.mValue.length === 0) {
                    return;
                }

                // 获取所有有效的直播间ID（过滤掉null和undefined）
                const roomIds = this.mValue
                    .filter(item => item && item.id) // 使用id而不是_id
                    .map(item => item.id);

                if (roomIds.length === 0) {
                    return; // 如果没有有效的ID，直接返回
                }
                
                // 使用API函数检查直播间状态
                const { status, data, message } = await checkLiveRooms({ roomIds });
                
                if (status === '10000') {
                    const validRoomIds = data || [];
                    
                    // 过滤出有效的直播间
                    this.mValue = this.mValue.filter(item => item && item.id && validRoomIds.includes(item.id));
                    
                    // 如果有直播间被过滤掉，发出警告
                    if (this.mValue.length < roomIds.length) {
                        console.warn('Some live rooms were filtered out due to deletion or other issues');
                    }
                } else {
                    this.$message.error(message || '检查直播间状态失败');
                }
            } catch (error) {
                console.error('Error checking live room status:', error);
                this.$message.error('检查直播间状态失败');
            }
        },

        openDynamicLiveDialog() {
            this.dialogVisible = true;
            this.dialogTitle = "选择动态数据";
            // 显示直播分类列表视图
            this.liveTypeVisible = true;
            this.liveVisible = false;
            this.videoVisible = false;
            
            // 确保有分类数据
            if (this.liveTypeList.length === 0) {
                this.getliveType1();
            }
        },

        openDialog() {
            this.dialogVisible = true;
            this.dialogTitle = "选择数据源";
            
            // 始终使用直播列表
            this.liveVisible = true;
            this.liveTypeVisible = false;
            this.videoVisible = false;
        },

        async getliveType1() {
            try {
                // 使用正确的API获取直播分类数据
                const { status, data, message } = await getLiveTypeList({
                    page: 1,
                    pageSize: 100,
                });
                
                if (status == 10000) {
                    // 确保取到正确的分类数据结构
                    this.liveTypeList = data.categories || data || [];
                    console.log('获取直播分类数据成功:', this.liveTypeList);
                } else {
                    throw new Error(message);
                }
            } catch (error) {
                console.error('获取直播分类数据失败:', error);
                this.$message.error(error?.message || '获取分类数据失败');
                this.liveTypeList = [];
            }
        },

        async getliveList() {
            try {
                // 通过 room/list 获取直播列表数据
                const { status, data, message } = await getLiveList({
                    category: this.liveType1,
                    subCategory: this.liveType2,
                    page: 1,
                    pageSize: this.mOptions?.limit || 8,
                });
                
                if (status == 10000 && data && data.rooms) {
                    const customUrl = this.customUrl;
                    
                    // 将API返回的直播数据格式化为组件所需的格式
                    this.list = data.rooms.map((item) => {
                        return {
                            id: item._id,
                            title: item.title,
                            image: item.cover,
                            liveUrl: item.liveUrl,
                            watchCount: item.views || 0,
                            status: item.status || 'upcoming',
                            startTime: item.startTime || '',
                            description: item.description || '',
                            jump: {
                                id: customUrl,
                                type: "custom",
                                param: item._id
                            }
                        };
                    });
                    
                    console.log('获取直播列表成功:', { 
                        count: this.list.length,
                        firstItem: this.list[0] || null
                    });
                } else {
                    throw new Error(message || '获取直播列表返回异常数据');
                }
            } catch (error) {
                console.error('获取直播列表失败:', error);
                this.$message.error(error?.message || '获取直播列表失败');
                this.list = [];
            }
        },

        // 自定义数据返回的回调
        async handleSelectionChange(val) {
            console.log('选择直播数据:', val);
            // 保存选中的直播间数据
            this.list = val;
            
            // 设置最大选择数量
            if (this.mOptions.limit && val.length > this.mOptions.limit) {
                this.$message.warning(`最多只能选择${this.mOptions.limit}个直播`);
                return;
            }
            
            // 将选中的直播添加到mValue，用于界面显示
            this.setVideoList();
            
            // 选择新数据时也检查一次删除状态
            await this.checkDeletedLives();
            
            // 发送更新事件
            this.$emit('update:modelValue', this.mValue);
            this.$emit('input', this.mValue);
        },
        
        setVideoList() {
            const customUrl = this.customUrl;
            
            // 格式化直播数据
            const formattedList = this.list.map((item) => {
                return {
                    ...item,
                    jump: {
                        id: customUrl,
                        type: "custom",
                        param: item.id
                    }
                };
            });
            
            // 不是追加，而是替换，避免重复选择
            this.mValue = [...formattedList];
            
            console.log('已选择的直播数据:', this.mValue.length, this.mValue);
        },

        setLiveKeyword(){
            console.log('=== setLiveKeyword() 方法执行 ===');
            console.log('liveTypeRef:', this.$refs.liveTypeRef);
            console.log('checkedList 原始数据:', this.$refs.liveTypeRef ? this.$refs.liveTypeRef.getCheckedList() : 'liveTypeRef不存在');
            
            const checkedList = this.$refs.liveTypeRef ? this.$refs.liveTypeRef.getCheckedList() : [];
            console.log('选中的分类数据:', checkedList);
            
            // 确保子类中包含的只是被选中的项目
            checkedList.forEach(category => {
                if (category.child && category.child.length) {
                    // 只保留选中的子分类
                    category.child = category.child.filter(subCat => subCat.checked);
                }
            });
            
            console.log('处理后的分类数据:', checkedList);
            console.log('checkedList.length:', checkedList.length);
            
            // 设置分类数据到控件属性
            this.control.curWidget.attrs.tabs = checkedList;
            
            // 清空已选的静态直播数据
            this.mValue = [];
            
            console.log('选择的分类数据已保存:', checkedList);
            console.log('attrs.tabs 已设置为:', this.control.curWidget.attrs.tabs);
            console.log('attrs.tabs.length:', this.control.curWidget.attrs.tabs.length);
            console.log('attrs.tabs JSON:', JSON.stringify(this.control.curWidget.attrs.tabs, null, 2));
            
            // 打印完整的 curWidget 结构
            console.log('curWidget 完整结构:', {
                id: this.control.curWidget.id,
                component: this.control.curWidget.component,
                attrs: JSON.parse(JSON.stringify(this.control.curWidget.attrs))
            });
        },

        done() {
            console.log('=== done() 方法执行 ===');
            console.log('liveVisible:', this.liveVisible);
            console.log('liveTypeVisible:', this.liveTypeVisible);
            
            if (this.liveVisible) {
                // 选择数据源模式：使用静态直播数据
                
                // 检查最大数量限制
                if (this.mOptions.limit && this.mValue.length > this.mOptions.limit) {
                    this.$message.warning(`最多只能选择${this.mOptions.limit}个直播`);
                    return;
                }
                
                // LiveList组件已经在handleSelectionChange中更新了this.mValue
                // 但我们还需要确保将mValue值同步回去
                this.$emit('update:modelValue', this.mValue);
                this.$emit('input', this.mValue);
                
                // 清空动态数据分类
                this.control.curWidget.attrs.tabs = [];
                
                console.log('直播选择完成，数据量:', this.mValue.length);
                this.dialogVisible = false;
            } else if (this.liveTypeVisible) {
                // 动态数据模式：使用分类数据
                
                // 获取LiveTypeList组件选中的分类数据并保存
                this.setLiveKeyword();
                
                this.dialogVisible = false;
            } else {
                this.dialogVisible = false;
            }
        },

        addItem() {
            if (this.mValue.length >= this.mOptions?.limit) {
                this.$notify({
                    title: "无法新增",
                    message: `最多只能添加${this.mOptions?.limit}条数据`,
                    type: "warning",
                });
                return;
            }

            this.mValue.push({
                id: this.$getRandomCode(6),
            });
        },

        delItem(id) {
            let i = this.mValue.findIndex((item) => item.id == id);
            this.mValue.splice(i, 1);
        },

        // 在组件销毁时清除缓存
        beforeDestroy() {
            localStorage.removeItem(this.cacheKey);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .config-item {
    margin-bottom: 10px !important;
}

.p10 {
    padding: 10px;
}

.ml-auto {
    margin-left: auto;
}

.flex-row {
    display: flex;
    flex-direction: row;
}

.flex-end {
    justify-content: flex-end;
}
</style>